import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { EasmRelatedFindingsDataProviderFactory } from '../factory/EasmRelatedFindingsDataProviderFactory';
import EasmRelatedFindingsDataProvider from '../dataProvider/EasmRelatedFindingsDataProvider';
import { FindingGroup } from '../../findingDetails/findingDetails/types';

export default class EasmRelatedFindingsRepository extends BaseWebComponentRepository {
  public dataProviderFactory: EasmRelatedFindingsDataProviderFactory;
  public dataProvider: EasmRelatedFindingsDataProvider;

  public constructor() {
    super();

    this.initialSetup({
      dataProviderFactory: new EasmRelatedFindingsDataProviderFactory(),
    });
  }

  public getFindingGroups(allFindingGroups: FindingGroup[], searchText: string): FindingGroup[] {
    return this.dataProvider.getFindingGroups(allFindingGroups, searchText);
  }
}
